/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Import jQuery and Slick Carousel from node_modules
import $ from 'jquery';
import 'slick-carousel';

// Ensure jQuery is available globally (required by Slick)
window.jQuery = window.$ = $;

document.addEventListener('DOMContentLoaded', () => {

    // Function to check and add background-red class
    function addBackgroundClass(element) {
        // Get the inline background color (returns rgb, rgba, or hex)
        const bgColor = element.style.backgroundColor;

        // Check if background color matches #F3FBF8
        if (bgColor === 'rgb(243, 251, 248)') {
            element.classList.add('background-green');
        }
        

        // Check if background color matches #f3dbdc
        if (bgColor === 'rgb(243, 219, 220)') {
            element.classList.add('background-red');
        }

        // Check if background color matches #FFF8F0
        if (bgColor === 'rgb(255, 248, 240)') {
            element.classList.add('background-yellow');
        }
    }

    // Target all elements with .has-background (e.g., group blocks)
    const groupBlocks = document.querySelectorAll('.has-background');
    groupBlocks.forEach(block => addBackgroundClass(block));

    // Debounce function to limit how often a function is called
    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args);
            }, wait);
        };
    }


    // Find all carousel instances
    const carousels = document.querySelectorAll('.wp-block-showstopper-products-carousel .wp-block-woocommerce-product-collection > .wp-block-woocommerce-product-template');
    carousels.forEach((carousel) => {
        // Initialize Slick Carousel
        $(carousel).slick({
            slidesToShow: 4,      // Default: 1 item per view
            slidesToScroll: 1,    // Scroll one slide at a time
            infinite: true,       // Loop if more than 1 item
            variableWidth: false,
            centerMode: false,
            arrows: true,        // We'll add custom buttons
            dots: true,          // Show pagination dots
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        dots: false
                    }
                }
            ]
        });

        // Equalize slide heights
        function equalizeSlideHeights() {
            const slides = carousel.querySelectorAll('.slick-slide');
            let maxHeight = 0;

            // Reset heights to auto to measure natural height
            slides.forEach(slide => {
                slide.style.height = 'auto';
                const slideHeight = slide.offsetHeight;
                maxHeight = Math.max(maxHeight, slideHeight);
            });

            // Apply max height to all slides
            slides.forEach(slide => {
                slide.style.height = `${maxHeight}px`;
            });
        }

        // Run on load and after slide change
        equalizeSlideHeights();
        $(carousel).on('afterChange', equalizeSlideHeights);

        // Add debounced resize event listener
        const debouncedEqualize = debounce(equalizeSlideHeights, 250);
        window.addEventListener('resize', debouncedEqualize);
        
        // Clean up event listener when carousel is destroyed (if needed)
        $(carousel).on('destroy', () => {
            window.removeEventListener('resize', debouncedEqualize);
        });
    });
});
